import * as React from "react"
import Logo from "../icons/logo"
import {
  footerStyle,
  copyright,
  links,
  blurb,
  logos,
  footerNavList,
  footerNavListItem,
} from "./footer.module.css"
import "@fontsource/benne"
import { Link } from "gatsby"
import { styled } from "../styles/stitches.config"

export function Footer() {
  const FooterLinks = styled('div', {
    '@bp1': {
      display: 'flex',
      flexFlow: 'column wrap',
    },
    '& a': {
      fontFamily: '$lato',
      display: 'inline-block',
      padding: '0 12px',
    }
  });

  const FooterInfo = styled('div', {
    display: 'flex',
    flexFlow: 'column wrap',
    alignItems: 'center',
    h4: {
      fontFamily: '$default !important',
      marginTop: '18px',
      marginBottom: '18px',
    },
    p: {
      fontFamily: '$lato',
    },
    div: {
      maxWidth: '500px',
    },
    '& a': {
      fontFamily: '$lato',
      display: 'inline-block',
      padding: '0 12px',
    }
  });

  return (
    <footer className={footerStyle}>
      <div className={blurb}>
        <FooterInfo>
          <div>
            {/* <Logo /> */}
            <h4>BETTER DAYS SKIN CO.</h4>
            <p>Better Days was born out of the frustration of not being able to find gentle yet effective multi-purpose skincare products formulated for sensitive skin. We are here to make things simple, so you can feel comfortable in your own skin.</p><br />

          </div>
        </FooterInfo>
        <FooterLinks className="footerLinks">
          <Link to="/pages/terms-and-conditions">Terms and Conditions</Link>
          <Link to="/pages/shipping-and-returns">Shipping and Returns</Link>
          <Link to="/pages/privacy-policy">Privacy Policy</Link>
          <Link to="/pages/frequently-asked-questions">FAQs</Link>
        </FooterLinks>
      </div>
      <nav className={links} aria-label="footer">
        <ul className={footerNavList}>
          {/* <li className={footerNavListItem}>
            <a href="https://github.com/gatsbyjs/gatsby-starter-shopify">
              Source Code and Docs
            </a>
          </li> */}
          {/* <li className={footerNavListItem}>
            <a href="https://www.gatsbyjs.com/cloud/">About Gatsby Cloud</a>
          </li> */}
          {process.env.GATSBY_DEMO_STORE === "true" && (
            <li className={footerNavListItem}>
              <a href="https://www.gatsbyjs.com/dashboard/deploynow?url=https://github.com/gatsbyjs/gatsby-starter-shopify&utm_campaign=shopify-starter">
                <img
                  src="https://www.gatsbyjs.com/deploynow.png"
                  alt="Deploy to Gatsby Cloud"
                  height="38"
                  width="251"
                />
              </a>
            </li>
          )}
        </ul>
      </nav>
      <div className={copyright} style={{ fontFamily: 'Benne' }}>
        Copyright &copy; {new Date().getFullYear()} Better Days · All rights reserved
      </div>
    </footer>
  )
}
